<svelte:options tag="mf-modal"/>
<script>

    import axios from 'axios';
    import {onMount} from "svelte";
    import {currentCountry, configCountry} from "../../util/url-builder";

    const assets = `${configCountry().domain}/assets/cancel.svg`;
    let bannerData = null;
    let showModal = true;

    const handleHideModal = () => showModal = !showModal;

    onMount(async ()=> {
        const countryCode = currentCountry() === 'dev' ? 'co' : currentCountry();
        const { data } = await axios.get('/api/gema/banners');
        bannerData = data.find( ( { code_iso, name } ) =>
                code_iso === countryCode && name === 'banner_home')
    })
</script>

<div>
    {#if bannerData && bannerData['active'] && showModal}
        <div class="wrapper" on:click={handleHideModal}>
            {#if bannerData && bannerData['img_desktop'] }
                <div class="container" on:click={handleHideModal}>
                    <a href='#' onClick={handleHideModal}>
                        <img src={assets} alt="closed">
                    </a>
                    <a href={bannerData['url']}>
                        <img src={bannerData['img_desktop'][0].url}/>
                    </a>
                </div>
            {/if}
        </div>
    {/if}
</div>


<style type="text/scss">

    .wrapper {
        position: fixed;
        display: flex;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: rgba(0, 0, 0, 0.42);
        z-index: 11;
        cursor: pointer;
    }

    .container {
        width: 320px;
        height: 488px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        a:first-child {
            z-index: 11;
            position: relative;
            left: 45%;
            width: 25px;
            top: -29%;
        }

        a:nth-child(2):hover {
            -webkit-box-shadow: 11px 9px 9px -12px #000000;
            box-shadow: 11px 9px 9px -12px #000000;
        }

        img:last-child {
            max-width: 320px;
            max-height: 488px;
        }

        @media (min-width: 768px) {
            width: 600px;

            a:first-child {
                z-index: 11;
                position: relative;
                left: 47%;
                width: 25px;
                top: 6%;
            }

            img:last-child {
                max-width: 600px;
            }
        }
    }
</style>






